/**
 * Corporate client course navigation simplification.
 *
 * When EDVERUM_CLIENT=corporate, the course sidebar hides administrative
 * menu items that are out of scope and renames Gradebook to Progress.
 */

/** Menu node keys hidden from the corporate course navigation tree. */
export const CORPORATE_HIDDEN_COURSE_MENU_KEYS = Object.freeze([
    'gradebook-preview',
    'course-reports',
    'meetings',
    'attempt-authorizations',
    'my-notes',
    'remediation',
    'course-log',
    'due-dates',
]);

/** Route names that redirect to course-dashboard in corporate mode. */
export const CORPORATE_REMOVED_COURSE_ROUTE_NAMES = Object.freeze([
    'course-gradebook-preview',
    'course-reports',
    'discussion-thread-report',
    'course-meetings-view-upcoming',
    'course-meetings-view-previous',
    'course-meetings-view',
    'course-meeting-view',
    'course-attempt-authorizations-view',
    'course-notes',
    'course-remediation',
    'course-activities-view-upcoming',
    'course-activities-view-previous',
    'course-time-periods-view-upcoming',
    'course-time-periods-view-previous',
]);

export const CORPORATE_GRADEBOOK_MENU_LABEL = 'Progress';

export const DEFAULT_GRADEBOOK_MENU_LABEL = 'Gradebook';

export const CORPORATE_META_MENU_LABEL = 'Course Info';

/** Label for the consolidated corporate destination that merges progress + enrollments. */
export const CORPORATE_ENROLLMENT_PROGRESS_MENU_LABEL = 'Enrollment & Progress';

/**
 * Corporate course routes that are merged into the consolidated
 * "Enrollment & Progress" destination. Direct navigation to these old routes
 * redirects to the new page (preserving the courseId), rather than 404ing.
 */
export const CORPORATE_COURSE_ROUTE_REDIRECTS = Object.freeze({
    'gradebook-view': 'course-progress-view',
    'course-enrollments-view': 'course-progress-view',
});

/** Expected top-level corporate menu flow (curriculum nodes appear flat after dashboard). */
export const CORPORATE_COURSE_MENU_ORDER = Object.freeze([
    'course-dashboard',
    'grades',
    'enrollment-progress',
    'due-dates',
    'attendance',
]);

/**
 * @param {string} key
 * @returns {boolean}
 */
export function isCorporateHiddenCourseMenuKey(key) {
    return CORPORATE_HIDDEN_COURSE_MENU_KEYS.includes(key);
}

/**
 * @param {string} routeName
 * @returns {boolean}
 */
export function isCorporateRemovedCourseRoute(routeName) {
    return CORPORATE_REMOVED_COURSE_ROUTE_NAMES.includes(routeName);
}

/**
 * Target route name a merged corporate route should redirect to, or null.
 *
 * @param {string} routeName
 * @returns {string|null}
 */
export function corporateCourseRouteRedirect(routeName) {
    return CORPORATE_COURSE_ROUTE_REDIRECTS[routeName] ?? null;
}
